module.exports = __webpack_public_path__ + "static/media/sk1.a21b5036.jpg";